import loadable from '@loadable/component';
import LoadingComponent from 'components/Loaders/LoadingComponent';

const ReceptacleLoadable = loadable(() => import('./Receptacles'), {
  fallback: <LoadingComponent />,
});

export default ReceptacleLoadable;
